import React from 'react';
import { FT170, FT174, t207Api } from '../../../services/t207Api';

interface Tab2Props {
  formData: Partial<FT170>;
  vendorPeople: Partial<FT174>[];
  isEditing: boolean;
  addVendorRow: () => void;
  deleteVendorRow: (idx: number) => void;
  setVendorField: (idx: number, key: keyof FT174, value: FT174[keyof FT174]) => void;
  selectedVendorIdx: number;
  setSelectedVendorIdx: (idx: number) => void;
}

/** Tab 2: Vendor Attendees (Page2 from ui_spec - FT174) */
const Tab2VendorPeople: React.FC<Tab2Props> = React.memo(({
  formData, vendorPeople, isEditing,
  addVendorRow, deleteVendorRow, setVendorField,
  selectedVendorIdx, setSelectedVendorIdx,
}) => (
  <div>
    <div className="form-grid" style={{ marginBottom: 12 }}>
      <label>廠商參加人數</label>
      <input
        type="number"
        value={formData.ft170_25 ?? 0}
        readOnly
        style={{ width: 80 }}
      />
    </div>

    <div className="table-wrapper">
      <div className="table-toolbar">
        <div className="left">
          <span style={{ fontWeight: 500, fontSize: 13 }}>廠商參加人員</span>
        </div>
        <div className="right">
          <button className="btn btn-sm" disabled={!isEditing} onClick={addVendorRow}>明細新增</button>
          <button className="btn btn-sm btn-danger" disabled={!isEditing || vendorPeople.length === 0}
            onClick={() => deleteVendorRow(selectedVendorIdx)}>明細刪除</button>
        </div>
      </div>
      <div className="table-scroll" style={{ maxHeight: 340 }}>
        <table className="data-table">
          <thead>
            <tr>
              <th style={{ width: 56 }}>序號</th>
              <th style={{ width: 93 }}>姓名</th>
              <th style={{ width: 99 }}>職稱</th>
              <th style={{ width: 186 }}>部門</th>
              <th style={{ width: 112 }}>廠商代號</th>
              <th style={{ width: 200 }}>廠商名稱</th>
            </tr>
          </thead>
          <tbody>
            {vendorPeople.map((row, idx) => (
              <tr
                key={idx}
                className={idx === selectedVendorIdx ? 'selected' : ''}
                onClick={() => setSelectedVendorIdx(idx)}
              >
                <td>{row.ft174_02}</td>
                <td>
                  <input
                    type="text"
                    value={row.ft174_10 || ''}
                    onChange={e => setVendorField(idx, 'ft174_10', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.ft174_11 || ''}
                    onChange={e => setVendorField(idx, 'ft174_11', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.ft174_12 || ''}
                    onChange={e => setVendorField(idx, 'ft174_12', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.ft174_13 || ''}
                    onChange={e => setVendorField(idx, 'ft174_13', e.target.value)}
                    onBlur={async () => {
                      const code = row.ft174_13 || '';
                      if (!code) return;
                      const name = await t207Api.lookupName('vendor', code);
                      setVendorField(idx, 'ft174_14', name);
                    }}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>{row.ft174_14 || ''}</td>
              </tr>
            ))}
            {vendorPeople.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'rgba(0,0,0,0.25)' }}>無資料</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
));

Tab2VendorPeople.displayName = 'Tab2VendorPeople';
export default Tab2VendorPeople;
